import { Html5Qrcode } from "html5-qrcode";
const { buildStaffMemberInfoHtml } = require("./_staff_member_info");

function staffApiErrorMessage(data, fallback) {
    if (!data || !data.messages) {
        return fallback;
    }

    if (typeof data.messages === "string") {
        return data.messages;
    }

    const flat = Object.values(data.messages).flat();

    if (flat.length > 0 && flat[0]) {
        return flat[0];
    }

    return fallback;
}

function getScanMemberStatusMessage(data) {
    if (data.status_souvenir_full) {
        return "สิทธิ์เต็มแล้ว";
    }

    if (!data.status_check) {
        return "ใช้สิทธิ์แล้ว";
    }

    return "";
}

function getBootstrapModal(element) {
    if (!element || !window.bootstrap || !window.bootstrap.Modal) {
        return null;
    }

    return window.bootstrap.Modal.getOrCreateInstance(element);
}

$(function () {
    if ($(".js-qr-reader").length > 0) {
        const scanMemberInfoModalElement = document.getElementById("scanMemberInfoModal");
        const scanPointModalElement = document.getElementById("scanPointModal");
        const scanMemberInfoModal = getBootstrapModal(scanMemberInfoModalElement);
        const scanPointModal = getBootstrapModal(scanPointModalElement);
        const memberInfoContent = $(".js-scan-member-info-content");
        const memberInfoStatus = $(".js-scan-member-info-status");
        const memberInfoConfirmBtn = $(".js-scan-member-info-confirm");
        const qrReader = $(".js-qr-reader");
        const collectUrl = qrReader.data("url");
        const reimbursementOptions = qrReader.data("reimbursementOptions") || {};
        const attendanceTypeOptions = qrReader.data("attendanceTypeOptions") || {};

        let pendingScanData = null;
        let pendingScanHash = null;
        let html5QrCode = null;

        function resumeQrScan() {
            pendingScanData = null;
            pendingScanHash = null;

            if (html5QrCode) {
                html5QrCode.resume();
            }
        }

        function showScanSuccessModal(data) {
            if (!scanPointModal) {
                resumeQrScan();
                return;
            }

            $("#scanPointModal").attr("data-member-rc-id", data.member_rc_id || "");

            window.setTimeout(function () {
                scanPointModal.show();
            }, 100);
        }

        function showScanMemberInfoModal(data) {
            pendingScanData = data;

            if (!scanMemberInfoModal) {
                console.error("scanMemberInfoModal not found");

                if (data.status_check && !data.status_souvenir_full) {
                    submitCheckIn();
                } else {
                    resumeQrScan();
                }

                return;
            }

            memberInfoContent.html(buildStaffMemberInfoHtml(data, {
                attendanceTypeOptions,
                reimbursementOptions,
            }));

            const statusMessage = getScanMemberStatusMessage(data);

            if (statusMessage) {
                memberInfoStatus.text(statusMessage).removeClass("d-none");
                memberInfoConfirmBtn.text("ตกลง");
            } else {
                memberInfoStatus.text("").addClass("d-none");
                memberInfoConfirmBtn.text("ยืนยัน Check-in");
            }

            scanMemberInfoModal.show();
        }

        function submitCheckIn() {
            if (!pendingScanHash) {
                resumeQrScan();
                return;
            }

            memberInfoConfirmBtn.prop("disabled", true);

            const formData = new FormData();
            formData.append("rc", qrReader.data("rc"));
            formData.append("hash", pendingScanHash);

            axios
                .post(collectUrl, formData)
                .then(function (response) {
                    const data = response.data;

                    if (data.status === "error") {
                        window.rduNotify(
                            staffApiErrorMessage(data, "ไม่สามารถ Check-in ได้"),
                            "warning"
                        );
                        resumeQrScan();
                        return;
                    }

                    if (data.status_souvenir_full) {
                        pendingScanData = data;
                        showScanMemberInfoModal(data);
                        return;
                    }

                    if (data.status_check) {
                        pendingScanData = null;
                        showScanSuccessModal(data);
                        return;
                    }

                    pendingScanData = data;
                    showScanMemberInfoModal(data);
                })
                .catch(function (error) {
                    console.log(error);
                    window.rduNotify("ไม่สามารถ Check-in ได้", "warning");
                    resumeQrScan();
                })
                .finally(function () {
                    memberInfoConfirmBtn.prop("disabled", false);
                });
        }

        memberInfoConfirmBtn.on("click", function () {
            const data = pendingScanData;

            if (!data) {
                scanMemberInfoModal && scanMemberInfoModal.hide();
                resumeQrScan();
                return;
            }

            if (data.status_check && !data.status_souvenir_full) {
                scanMemberInfoModal.hide();
                submitCheckIn();
                return;
            }

            scanMemberInfoModal.hide();
            resumeQrScan();
        });

        Html5Qrcode.getCameras()
            .then((devices) => {
                if (devices && devices.length) {
                    var cameraId = devices[0].id;

                    html5QrCode = new Html5Qrcode("qr-reader");
                    let options = cameraId;

                    if (window.location.hostname != "localhost") {
                        if (
                            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                navigator.userAgent
                            )
                        ) {
                            options = { facingMode: { exact: "environment" } };
                        }
                    }

                    html5QrCode
                        .start(
                            options,
                            {
                                fps: 10,
                                qrbox: 250,
                                aspectRatio: 1,
                            },
                            (qrCodeMessage) => {
                                if (!qrCodeMessage) {
                                    return;
                                }

                                html5QrCode.pause(true);
                                pendingScanHash = qrCodeMessage;

                                const formData = new FormData();
                                formData.append("rc", qrReader.data("rc"));
                                formData.append("hash", qrCodeMessage);
                                formData.append("preview", "1");

                                axios
                                    .post(collectUrl, formData)
                                    .then(function (response) {
                                        const data = response.data;

                                        if (data.status == "error") {
                                            window.rduNotify(
                                                staffApiErrorMessage(
                                                    data,
                                                    "ไม่พบข้อมูลสมาชิก"
                                                ),
                                                "warning"
                                            );
                                            resumeQrScan();
                                            return;
                                        }

                                        showScanMemberInfoModal(data);
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                        window.rduNotify(
                                            "ไม่พบข้อมูลของสมาชิก",
                                            "warning"
                                        );
                                        resumeQrScan();
                                    });
                            }
                        )
                        .catch((err) => {
                            console.log(`Unable to start scanning, error: ${err}`);
                        });

                    $(".js-close-scan-modal").click(function () {
                        resumeQrScan();
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });

        let fist_device = null;
        if (window.matchMedia("(orientation: landscape)").matches) {
            fist_device = "landscape";
        }

        $(window).on("orientationchange", function (event) {
            if (fist_device == "landscape") {
                window.location.reload();
            }
        });
    }
});
